import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tabs } from 'antd'

import { Panel } from '../../../core/components/styled'
import {
  createUrl,
  getQueryParams,
} from '../../../core/utils/services/queryParams'

import { useDocumentTitle } from '../../../common/hooks/effects'

import {
  HtmlNonTemplateTab,
  HtmlTemplateTab,
  ImagesTab,
  PdfTab,
} from './sections'

const TABS = [
  { key: 'html-non-template', label: 'HTML Non-Template' },
  { key: 'html-template', label: 'HTML Template' },
  { key: 'pdf', label: 'PDF' },
  { key: 'images', label: 'Images' },
]

const TAB_COMPONENTS = {
  'html-non-template': HtmlNonTemplateTab,
  'html-template': HtmlTemplateTab,
  pdf: PdfTab,
  images: ImagesTab,
}

const AdvancedProbePage = () => {
  useDocumentTitle('Advanced Probe')

  const history = useHistory()
  const { pathname, search } = useLocation()
  const { advancedProbeTab } = getQueryParams(search)
  const [activeTabKey, setActiveTabKey] = useState(
    TABS.find(tab => tab.key === advancedProbeTab)?.key || TABS[0].key,
  )

  useEffect(() => {
    const nextActiveKey =
      TABS.find(tab => tab.key === advancedProbeTab)?.key || TABS[0].key
    setActiveTabKey(nextActiveKey)
  }, [advancedProbeTab])

  const handleChangeTab = tabKey => {
    setActiveTabKey(tabKey)
    history.push(
      createUrl(pathname, search, {
        advancedProbeTab: tabKey,
      }),
    )
  }

  return (
    <>
      <Panel margin="small no">
        <Tabs
          type="card"
          activeKey={activeTabKey}
          onChange={handleChangeTab}
          destroyInactiveTabPane
        >
          {TABS.map(tab => {
            const TabComponent = TAB_COMPONENTS[tab.key]
            return (
              <Tabs.TabPane key={tab.key} tab={tab.label}>
                <TabComponent />
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </Panel>
    </>
  )
}

export default AdvancedProbePage
